import { defineStore } from "pinia";
import { DailyActivitiesStore } from "./dailyActivities";
import { useDependantAboutYouStore } from "./dependantAboutYou";

export const useDependantDailyActivitiesStore = defineStore("dependantDailyActivities", {
    state: () : DailyActivitiesStore => {
        return {
            dressYourself: null,
            applicantMobility: null,
            applicantTransferring: null,
            applicantBladder: null,
            applicantBowels: null,
            applicantBathing: null,
            applicantFeeding: null,
            applicantProgression: null,
        };
    },
    getters: {
        getDailyActivities(state) {
            return {
                dressYourself: state.dressYourself,
                applicantMobility: state.applicantMobility,
                applicantTransferring: state.applicantTransferring,
                applicantBladder: state.applicantBladder,
                applicantBowels: state.applicantBowels,
                applicantBathing: state.applicantBathing,
                applicantFeeding: state.applicantFeeding,
                applicantProgression: state.applicantProgression,
            };
        },
        dependantDailyActivitiesRequired(): boolean {
            const store = useDependantAboutYouStore();
            return !!store.medical;
        },
    },
});
